import React from 'react';
import styles from '../styles/Footer.module.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  // Get version from package.json via Vite's environment variable
  const appVersion = import.meta.env.VITE_APP_VERSION;

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <p className={styles.copyright}>
          &copy; {currentYear} by monteX2. All rights reserved.
        </p>
        {appVersion && (
          <p className={styles.version}>
            Version {appVersion}
          </p>
        )}
      </div>
    </footer>
  );
};


export default Footer;
